import $ from "jquery";

class CustomPdf {
    constructor() {
        this.list = $(".pdf-custom-list");

        this.events();
    }

    events() {
        this.list.on("change", 'input[type="checkbox"]', (e) =>
            this.processCheckboxChange(e)
        );
        this.list.on("click", ".pdf-custom-list__select-all--button", (e) =>
            this.processSelectAllBtn(e)
        );
    }

    // Methods
    processSelectAllBtn(e) {
        e.preventDefault();
        this.list.find(".pdf-custom-list__select-all").click();
        return false;
    }

    processCheckboxChange(e) {
        const target = $(e.target);

        if (target.hasClass("pdf-custom-list__select-all")) {
            if (target.is(":checked")) this.checkAll();
            else this.uncheckAll();
        } else {
            if (!target.is(":checked")) {
                this.list
                    .find(".pdf-custom-list__select-all")
                    .prop("checked", false);
            }
        }
    }

    uncheckAll() {
        this.list.find('input[type="checkbox"]').prop("checked", false);
    }

    checkAll() {
        this.list.find('input[type="checkbox"]').prop("checked", true);
    }
}

export default CustomPdf;
